// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__hDhGR","label":"styles_label__gzFve"};